// extracted by mini-css-extract-plugin
export default {"message_creation_date":"Message_message_creation_date__ZLcF9"};